module.exports = __webpack_public_path__ + "static/img/itadakimonster-logo.ba6309d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/itadakimonster-logo.png
// module id = 38W4
// module chunks = 0